<template>
  <div class="d-inline-block">
    <slot
      name="activator"
      :on="activatorListeners"
      :attrs="{}"
    >
      <v-btn
        icon
        :ripple="false"
        v-on="activatorListeners"
      >
        <v-icon
          small
        >
          {{ icons.mdiTrashCanOutline }}
        </v-icon>
      </v-btn>
    </slot>

    <!-- 確認メニューは開いた時だけマウントする(flyweight)。
         行ごとに使われるため v-menu を常駐させると行数ぶん積み上がる -->
    <v-menu
      v-if="isMounted"
      v-model="isOpen"
      :position-x="x"
      :position-y="y"
      absolute
    >
      <v-card>
        <v-card-text>
          <slot name="message">
            <p>
              {{ message }}
            </p>
            <p>
              {{ warningMessage }}
            </p>
          </slot>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            small
            color="secondary"
            @click="isOpen = false"
          >
            キャンセル
          </v-btn>
          <v-btn
            small
            color="error"
            @click="$emit('confirm')"
          >
            実行
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import {
  ref,
  watch,
  nextTick,
} from '@vue/composition-api'
import { mdiTrashCanOutline } from '@mdi/js'

export default {
  name: 'DeleteConfirmDialog',
  props: {
    icon: {
      type: String,
      default: 'mdiTrashCanOutline',
    },
    message: {
      type: String,
      default: '削除しますか？',
    },
    warningMessage: {
      type: String,
      default: 'この操作は取り消せません。',
    },
  },
  setup() {
    const isMounted = ref(false)
    const isOpen = ref(false)
    const x = ref(0)
    const y = ref(0)

    const open = event => {
      const rect = event.currentTarget.getBoundingClientRect()
      x.value = rect.left
      y.value = rect.bottom
      isMounted.value = true
      nextTick(() => {
        isOpen.value = true
      })
    }

    // 閉じたらアンマウントして常駐させない
    watch(isOpen, val => {
      if (!val) isMounted.value = false
    })

    return {
      isMounted,
      isOpen,
      x,
      y,
      activatorListeners: { click: open },

      icons: {
        mdiTrashCanOutline,
      },
    }
  },
}
</script>
